module.exports = __webpack_public_path__ + "static/img/user.c6267970.png";